import script from "./ProjectShowcaseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectShowcaseForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectShowcaseForm.vue?vue&type=style&index=0&id=4a9feabe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9feabe"]])

export default __exports__